import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col, Input, Label, FormGroup } from 'reactstrap';
import DynamicTable from 'components/DynamicTable';
//import bgimage from '../assets/img/icon/ms-excel.png';
//import ReactExport from "react-data-export";
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';
import Strings from '../strings/Strings';
import SelectAPI from '../components/SelectAPI';
//import BaseService from '../services/BaseService';

/* const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet; */
const returnColor = (number) => {
    if(parseInt(number, 10) === 0){
        return 'orange'
    }
    else if(parseInt(number, 10) > 0){
        return 'green'
    }
    else{
        return 'red'
    }
}

class ReportRespect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            sector: '',
            sectorInvalid: false,
            show_form_route: false,
            show_deleting: false,
            dateFrom: false,
            dateTo: false,
            columns: [
                { name: 'date', title: 'Data' },
                { name: 'totalRegular', title: 'Vagas Regulares' },
                { name: 'totalIrregular', title: 'Vagas Irregulares' },
                { name: 'respectTax', title: 'Taxa de Respeito', getCellValue: row => <p style={{color: returnColor(row.respectTax)}}>{parseFloat(parseFloat(row.respectTax).toFixed(2))}%</p> }
            ],
            exportData: [],
            reload: false,
            editingObj: null,
            delete_id: -1
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {

    }
    returnDate(type) {
        var da = new Date();
        var mounth = da.getMonth() + 1;
        var year = da.getFullYear();
        var data = new Date(year, mounth, 0);
        var day = data.getDate();
        if (da.getMonth() + 1 < 10) {
            mounth = "0" + (da.getMonth() + 1);
        }
        if (type === "to") {
            return year + "-" + mounth + "-" + day;
        } else {
            day = "01";
            return year + "-" + mounth + "-" + day;
        }
    }
    returnApi = () => {
        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");
        var date = "admin/statistics/respect-tax?start_date=" + date1 + "&end_date=" + date2 + "&sector=" + (this.state.sector.id ? this.state.sector.id : 0);
        return date
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }
    onReloded = () =>{
        this.setState({
            reload: !this.state.reload
        })
        this.returnApi();
    }
    render() {
        return (
            <Page
                title="Taxa de Respeito"
                className="UserAdviserPage">
                <Row>
                    <Col sm={3}>
                        {/* <ExcelFile element={<Button outline><img src={bgimage} alt="excel" /> Exportar para Excel</Button>}>
                            <ExcelSheet dataSet={this.getResults()} name="Employees">
                            </ExcelSheet>
                        </ExcelFile>
                        <br /> */}
                    </Col>
                </Row>
                <Row>
                    <Col sm={3} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                        <SelectAPI
                            label={'Selecione um Setor'}
                            name="sector"
                            placeholder={"Selecione um Setor"}
                            access_token={this.props.user.access_token}
                            api="admin/parking-spot-sector"
                            selectedOption={this.handleInputChange}
                            value={this.state.sector}
                            invalid={this.state.sectorInvalid} 
                            formFeedbackMsg={Strings.required_field}
                        />
                    </Col>
                    <Col sm={3}>
                    <br/>
                        <Button 
                            outline 
                            onClick={this.onReloded}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>
                </Row>
                <DynamicTable
                    api={this.returnApi()}
                    route="true"
                    hideButton={true}
                    user={this.props.user}
                    columns={this.state.columns}
                    dateFilter="false"
                    integratedFilter="false"
                    currencyColumns="false"
                    showPagingState="false"
                    filterState="false"
                    integratePag="false"
                    reload={this.state.reload}
                />
                
            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(ReportRespect)


// WEBPACK FOOTER //
// ./src/pages/ReportRespect.js